import React from 'react';
import { useMoney } from 'src/hooks/useMoney';
import { MenuItemEntity } from 'src/services/apis/types';

interface OrderLineProps {
  orderLine: {
    orderItem: MenuItemEntity | undefined;
    quantity: number;
    subTotal: number;
  };
  index: number;
}

const OrderLine = React.memo((props: OrderLineProps) => {
  const { format } = useMoney();
  return (
    <div className="order-item">
      <h4>{props.orderLine.orderItem?.name}</h4>
      <span>x{props.orderLine.quantity}</span>
      <h5>{format(props.orderLine.subTotal)}</h5>
    </div>
  );
});

export default OrderLine;
